module.exports = __webpack_public_path__ + "media/images/fill-1@2x-fbe1c18e3b59afa8eb143d0be49a6ea4.png";